import {
    GET_SALES_PAID_BILL_REPORT_REQUEST,
    GET_SALES_PAID_BILL_REPORT_SUCCESS,
    GET_SALES_PAID_BILL_REPORT_FAILURE,
    SET_SALES_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST,
    SET_SALES_PAID_BILL_PARTYWISE_REPORT_BILLS,
    SET_SALES_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST,
    SET_SALES_PAID_BILL_BROKERWISE_REPORT_BILLS,
    SET_SALES_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST,
    RESET_SALES_PAID_REPORT
} from '../types/sales-paid-bill-report-types';

const initialState = {
    salesPaidBillReport: {},
    salesPaidBillPartywiseBills: {},
    salesPaidBillPartywiseParties: {},
    salesPaidBillBrokerwiseBills: {},
    salesPaidBillBrokerwiseParties: {},
    salesPaidBillBrokerwiseBrokers: {},
    loading: false,
    data: null,
    error: null
};

const salesPaidBillReportReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SALES_PAID_BILL_REPORT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_SALES_PAID_BILL_REPORT_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null
            };

        case SET_SALES_PAID_BILL_PARTYWISE_REPORT_PARTY_LIST:
            return {
                ...state,
                loading: false,
                salesPaidBillPartywiseParties: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case SET_SALES_PAID_BILL_PARTYWISE_REPORT_BILLS:
            return {
                ...state,
                loading: false,
                salesPaidBillPartywiseBills: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case SET_SALES_PAID_BILL_BROKERWISE_REPORT_PARTY_LIST:
            return {
                ...state,
                loading: false,
                salesPaidBillBrokerwiseParties: {...(action.payload || {})},
                data: action.payload,
                error: null
            };
    
        case SET_SALES_PAID_BILL_BROKERWISE_REPORT_BILLS:
            return {
                ...state,
                loading: false,
                salesPaidBillBrokerwiseBills: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case SET_SALES_PAID_BILL_BROKERWISE_REPORT_BROKER_LIST:
            return {
                ...state,
                loading: false,
                salesPaidBillBrokerwiseBrokers: {...(action.payload || {})},
                data: action.payload,
                error: null
            };

        case GET_SALES_PAID_BILL_REPORT_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.error
            };

        case RESET_SALES_PAID_REPORT:
            return {
                ...state,
                salesPaidBillReport: {},
                salesPaidBillPartywiseBills: {},
                salesPaidBillPartywiseParties: {},
                salesPaidBillBrokerwiseBills: {},
                salesPaidBillBrokerwiseParties: {},
                salesPaidBillBrokerwiseBrokers: {},
                loading: false,
                data: null,
                error: null
            }

        default:
            return state;
    }
};

export default salesPaidBillReportReducer;
